import Input from './Input';
import { InputVariant } from './Input.types';
import type { IInputProps } from './Input.types';

export type { IInputProps };
export { InputVariant };

export default Input;
